import styled from 'styled-components';

import colours from 'theme/atoms/colours';
import * as Cards from 'theme/components/Cards.style';
import * as Text from 'theme/components/Text.style';

export const Card = styled(Cards.BaseCard)<{ $clickable?: boolean }>`
  align-items: flex-start;
  gap: 10px;
  justify-content: space-between;
  padding: 15px;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

  > button {
    flex-grow: 0;
    flex-shrink: 0;
  }

  &:focus-visible {
    outline: ${({ $clickable }) =>
      $clickable ? `2px solid ${colours.neutral[400]}` : 'none'};
    outline-offset: 2px;
  }
`;

export const Header = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 5px 0;
  width: 100%;
`;

export const PreviousUpdate = styled('div')`
  display: flex;
  align-items: flex-start;
  gap: 3px;
  width: 100%;
  color: ${colours.neutral[600]};

  svg {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
  }
`;

export const PreviousUpdateText = styled(Text.P1)`
  flex: 1 1 0;
  min-width: 0;
  word-break: break-word;
  color: ${colours.neutral[600]};
`;
